import React, { useState } from "react";
import { CardWithActions, LineDivider } from "@/components";
import { AppBar, Box } from "@mui/material";
import { TabbedNavigationWithBadges } from "@/components";

import MyTeamReport from "./MyTeamReport";
import TeamMemberReport from "./TeamMemberReport";




const EmployeeTracker = () => {
 
  const [tabIndex, setTabIndex] = useState(0);



  // Tabs with dynamic count
  const tabs = [
    { name: "My Team Report"  },
    // { name: "Team Member Report" },
  ];

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const renderContent = (
    <Box sx={{ p: (theme) => theme.spacing(0, 0) }}>
      {tabIndex === 0 && (
        <>
          <LineDivider /> <MyTeamReport/>
        </>
      )}
      {/* {tabIndex === 1 && (
        <>
          <LineDivider />
          <TeamMemberReport />
        </>
      )} */}
    </Box>
  );

  return (
    <CardWithActions headerTitle="Attendance Employee Tracker" headerActions={[]}>
    <MyTeamReport/>
      {/* <TabbedNavigationWithBadges
        tabs={tabs}
        value={tabIndex}
        onChange={handleTabChange}
        renderContent={renderContent}
      />{" "} */}
    </CardWithActions>
  );
};

export default EmployeeTracker;
